import UserInfoController from './user.info.controller';

export default {
    template: require('./user.info.tpl.html'),
    controller: UserInfoController
};
